const mutations = {
	['UPDATE_APP_INFO'] (state, payload) {
		state.appid = payload.appid || '';
		state.redirectURL = payload.redirectURL || '';
	},
};

export default mutations;